import { Box, Button } from "@mui/material";

const ButtonsComponent: React.FC<{ handleCancel; handleSubmit }> = ({
  handleCancel,
  handleSubmit,
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        width: "100%",
      }}
    >
      <Button
        variant="contained"
        sx={{
          display: "block",
          margin: "40px 0 0",
          padding: "10px",
          width: "150px",
          textTransform: "none",
          fontSize: "16px",
        }}
        onClick={handleCancel}
      >
        Cancel
      </Button>
      <Button
        variant="contained"
        sx={{
          display: "block",
          margin: "40px 0 0",
          padding: "10px",
          width: "150px",
          textTransform: "none",
          fontSize: "16px",
        }}
        onClick={handleSubmit}
      >
        Submit
      </Button>
    </Box>
  );
};

export default ButtonsComponent;
